import './categories-thumbs-slider.scss';

$('.categories-thumbs-slider').each(function () {
	new Swiper($(this), {
		slidesPerView: 'auto',
		freeMode: true,
		touchReleaseOnEdges: true,
		freeModeMomentumBounce: false
	});
});